module.exports = "/_next/static/images/banner_icon_store-1131879512e78fbcafaf29c25af27d59.svg";